document.addEventListener("DOMContentLoaded", () => {

    function fetchConfig(type = 'json') {
        return {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': `application/${type}`
            }
        };
    }
    
    let custom_arr = [];
    let variant = null;
    let variantPrice = null;
    let actuatorsQty = 1;
    let airFreightFee = 0;
    let selectedVarObj = null;

    
    const productConfig = window.productConfiguration || {};
    let selectedOtherOptions = [];


    const quantityInp = document.querySelector('.quantity__input');
    const strokeOptions = document.getElementById('actuator-stroke');
    const voltageOptions = document.getElementsByName('voltage');
    const feedbackOptions = document.getElementsByName('feedback');
    const wireOptions = document.getElementsByName('wire_length');
    const forceOptions = document.getElementsByName('force');
    const otherOptions = document.getElementsByName('other_options');
    const saltSprayOptions = document.getElementsByName('salt_spray_coating');

    const priceWrapper = document.querySelector('.custom-price .price__regular');
    const optionsList = document.querySelector('.options-list');

      let selectedSaltSprayCoating = {
        value: null,
        price: 0
    };

    let selectedStroke = {
        range: null,
        price: 0,
        fee: 0
    };
    let selectedVoltage = {
        value: null,
        price: 0
    };
    let selectedFeedback = {
        value: null,
        price: 0
    };
    let selectedWireLength = {
        value: null,
        price: 0
    };
    let selectedForce = {
        value: null,
        price: 0
    };

    let totalPrice = 0;
    let isAvailible = true;

    class CustomConstructor extends HTMLElement {
        constructor() {
            super();
            this.addEventListener("change", this.onConstructorChange);
            this.cartBtn = document.querySelector("#custom-actuator-submit-button");
            this.input = this.querySelector('.quantity__input');

            this.getVariantData();
            this.updateMasterId();
            this.updateQuanity();
            this.updateStroke();
            this.updateVoltage();
            this.updateFeedback();
            this.updateWireExt();
            this.updateForceOpt();
            this.hsFormCreate();
            this.updateOtherOptions();
            this.updateSaltSprayCoating();
            this.setupSaltSprayListener();
            this.setupShippingCalculation(); 
            this.setupQuantityChangeListener(); 
            this.setupParameterChangeListeners(); 
            this.setupShippingTooltip();
            this.updateTotalPrice();
            this.arrayCreate();

            this.connectedCallback();

            this.cartBtn.addEventListener("click", (e) => {
                e.preventDefault();

            

                const request = JSON.parse(JSON.stringify(custom_arr));
                const cartData = request.map((r) => ({
                  id: r.id,
                  quantity: r.quantity,
                  properties: r.properties,
                }));
    
                const config = fetchConfig("javascript");
                config.headers["X-Requested-With"] = "XMLHttpRequest";
                const formData = {};
                formData.items = cartData;
                config.body = JSON.stringify(formData);

                fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                  if (response.status) {
                    this.cartBtn.setAttribute("aria-disabled", true);
                    this.cartBtn.querySelector("span").classList.add("hidden");
                    this.error = true;
                    return;
                  } else if (!this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                  }
                })
                .catch((e) => {
                  console.log(e);
                })
                .finally(() => {
                //   this.cartBtn.classList.remove("loading");
                //   if (!this.error) this.cartBtn.removeAttribute("aria-disabled");
                });
            });
        }

        onConstructorChange() {

            this.getVariantData();
            this.updateMasterId();
            this.updateQuanity();
            this.updateStroke();
            this.updateVoltage();
            this.updateForceParams();
            this.updateFeedback();
            this.updateWireExt();
            this.updateForceOpt();
            this.updateOtherOptions();
            this.updateSaltSprayCoating();
            // this.setupShippingCalculation();
            this.hideShippingResults();
            this.updateTotalPrice();
            this.arrayCreate();
            this.connectedCallback();
        }
        getVariantData() {
            try {
                this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
            } catch (e) {
                console.error('Error parsing variant data:', e);
                this.variantData = [];
            }
            return this.variantData;
        }

        updateMasterId() {    
            // Get the selected options from the form
            const form = this.closest('form') || document.querySelector('form[id^="product-form-"]');
            const selects = form ? form.querySelectorAll('select[name^="options"]') : [];
            this.options = Array.from(selects).map(select => select.value);
            
            if (this.options.length === 0) {
                this.currentVariant = this.getVariantData()[0];
            } else {
                this.currentVariant = this.getVariantData().find((variant) => {
                    return !variant.options.map((option, index) => {
                        return this.options[index] === option;
                    }).includes(false);
                });
            }

            selectedVarObj = this.currentVariant;
            if (this.currentVariant) {
                variant = this.currentVariant.id;
                variantPrice = this.currentVariant.price;
            }
            
            return selectedVarObj;
        }

        updateQuanity() {
            actuatorsQty = parseFloat(quantityInp.value);
            return actuatorsQty;
        }

        updateStroke() {
            if (!strokeOptions || !productConfig.stroke_sizes) return;

            selectedStroke.range = Number(strokeOptions.value);

            const strokeConfig = productConfig.stroke_sizes.find(stroke => 
                selectedStroke.range >= stroke.size_min && 
                selectedStroke.range <= stroke.size_max
            );

            if (strokeConfig) {
                selectedStroke.price = strokeConfig.price;
                // Freight fee now comes from top-level freight fees table, not stroke_sizes
                selectedStroke.fee = this.getFreightFeeFromConfig(selectedStroke.range);
            } else {
                selectedStroke.price = 0;
                selectedStroke.fee = 0;
            }

            this.checkPotentiometerLimit();
            this.updateSaltSprayCoating();

            localStorage.setItem('selectedStroke', selectedStroke.range);
     
            return selectedStroke; 
        }

        // Returns array of freight fee ranges from product config
        getFreightFeeConfig() {
            // Support both `freight_fees` (preferred) and legacy `freight_fee`
            const list = productConfig.freight_fees || productConfig.freight_fee || [];
            return Array.isArray(list) ? list : [];
        }

        // Finds the fixed freight fee (in cents) for a given stroke in mm from config ranges
        getFreightFeeFromConfig(strokeMm) {
            const ranges = this.getFreightFeeConfig();
            if (!strokeMm || !ranges.length) return 0;
            const match = ranges.find(r => Number(strokeMm) >= Number(r.size_min) && Number(strokeMm) <= Number(r.size_max));
            return match ? Number(match.price) : 0;
        }

        // Computes per-item freight fee in cents for the current selection and quantity
        computeFreightFeePerUnitForQty(qty) {
            if (!selectedStroke.range) return 0;
            const quantity = Number(qty) || 0;
            if (quantity >= 7) {
                return this.computeWeightBasedFreightFeeCents();
            }
            return this.getFreightFeeFromConfig(selectedStroke.range);
        }

        // Weight-based freight fee for 8+ units: (base_kg + (delta_mm * kg_per_mm)) * $16
        computeWeightBasedFreightFeeCents() {
            const minStrokeSizeMm = Number(productConfig.min_stroke_size) || 0;
            const minStrokeWeightKg = Number(productConfig.min_stroke_weight) || 0;
            const weightPerExtraMmKg = Number(productConfig.weight_per_extra_mm) || 0;
            const strokeMm = Number(selectedStroke.range) || 0;
            const extraMm = Math.max(0, strokeMm - minStrokeSizeMm);
            const totalWeightKg = minStrokeWeightKg + (extraMm * weightPerExtraMmKg);
            // $16 USD per kg → 1600 cents
            const cents = Math.round(totalWeightKg * 1600);
            return isFinite(cents) ? cents : 0;
        }

      checkPotentiometerLimit() {
            if (!productConfig.feedbacks) return;
            
            const potentiometerOption = productConfig.feedbacks.find(f => f.value === 'Potentiometer');
            if (!potentiometerOption || !potentiometerOption.strokeLimit) return;
            
            const potentiometerRadio = Array.from(feedbackOptions).find(opt => opt.value === 'Potentiometer');
            if (!potentiometerRadio) return;
            
            const strokeValue = selectedStroke.range;
            const strokeLimit = potentiometerOption.strokeLimit;
            
            // Find the label and stroke limit text
            const radioWrapper = potentiometerRadio.closest('.radio-wrapper');
            const label = potentiometerRadio.nextElementSibling || 
                         radioWrapper?.querySelector(`label[for="${potentiometerRadio.id}"]`);
            const strokeLimitText = label?.querySelector('.stroke-limit-text');
            
            if (strokeValue > strokeLimit) {
                // If potentiometer is selected and stroke exceeds limit, deselect it
                if (potentiometerRadio.checked) {
                    potentiometerRadio.checked = false;
                    // Select "No Feedback" option instead
                    const noFeedbackRadio = Array.from(feedbackOptions).find(opt => opt.value === 'No Feedback');
                    if (noFeedbackRadio) {
                        noFeedbackRadio.checked = true;
                        this.updateFeedback();
                    }
                }
                // Disable the potentiometer option
                potentiometerRadio.disabled = true;
                // Update the label to show it's disabled
                if (label) {
                    label.style.opacity = '0.5';
                    label.title = `Not available for strokes over ${strokeLimit}mm (current: ${strokeValue}mm)`;
                }
                // Change the stroke limit text color to indicate it's exceeded
                if (strokeLimitText) {
                    strokeLimitText.style.color = '#d00';
                    strokeLimitText.style.textDecoration = 'line-through';
                }
            } else {
                // Enable the potentiometer option
                potentiometerRadio.disabled = false;
                if (label) {
                    label.style.opacity = '1';
                    label.title = '';
                }
                // Reset the stroke limit text style
                if (strokeLimitText) {
                    strokeLimitText.style.color = '#666';
                    strokeLimitText.style.textDecoration = 'none';
                }
            }
            
            // Optional: Add visual feedback when approaching the limit
            if (strokeLimitText && strokeValue > strokeLimit * 0.8 && strokeValue <= strokeLimit) {
                strokeLimitText.style.color = '#ff6600'; // Orange when approaching limit
            }
        }
      
        updateOtherOptions() {
            if (!otherOptions || !productConfig.other_options) return;
            
            selectedOtherOptions = [];
            otherOptions.forEach(opt => {
                if (opt.checked) {
                    const optionConfig = productConfig.other_options.find(o => o.value === opt.value);
                    if (optionConfig) {
                        selectedOtherOptions.push({
                            value: opt.value,
                            price: optionConfig.price
                        });
                    }
                }
            });
            
            return selectedOtherOptions;
        }
      
      updateSaltSprayCoating() {
          const saltSprayCheckbox = document.querySelector('input[name="salt_spray_coating"]');
          
          if (!saltSprayCheckbox || !productConfig.salt_spray_coating) {

              selectedSaltSprayCoating = {
                  value: null,
                  price: 0
              };
              return selectedSaltSprayCoating;
          }
          
          if (saltSprayCheckbox.checked && selectedStroke.range) {
              // Find the appropriate price based on stroke range
              const coatingConfig = productConfig.salt_spray_coating.find(coating => 
                  selectedStroke.range >= coating.size_min && 
                  selectedStroke.range <= coating.size_max
              );
              
              if (coatingConfig) {
                  selectedSaltSprayCoating = {
                      value: "Salt Spray Coating",
                      price: coatingConfig.price
                  };
                  console.log('Salt spray selected:', selectedSaltSprayCoating);
                  
                  // Update global price for legend update
                  window.saltSprayPrice = coatingConfig.price;
                  
                  // Trigger legend update if function exists
                  if (typeof window.updateAdditionalOptionsLegend === 'function') {
                      window.updateAdditionalOptionsLegend();
                  }
              } else {
                  selectedSaltSprayCoating = {
                      value: null,
                      price: 0
                  };
                  // Disable checkbox if stroke is out of range
                  saltSprayCheckbox.checked = false;
                  saltSprayCheckbox.disabled = true;
              }
          } else {
              selectedSaltSprayCoating = {
                  value: null,
                  price: 0
              };
              
              // Clear global price for legend update
              window.saltSprayPrice = 0;
              
              // Trigger legend update if function exists
              if (typeof window.updateAdditionalOptionsLegend === 'function') {
                  window.updateAdditionalOptionsLegend();
              }
          }
          
          // Update the display
          this.updateSaltSprayPriceDisplay();
          
          return selectedSaltSprayCoating;
      }
      setupSaltSprayListener() {
            const saltSprayCheckbox = document.querySelector('input[name="salt_spray_coating"]');
            if (saltSprayCheckbox) {
                saltSprayCheckbox.addEventListener('change', () => {
                    console.log('Salt spray checkbox changed:', saltSprayCheckbox.checked);
                    this.updateSaltSprayCoating();
                    this.updateTotalPrice();
                });
                
                // Initialize the price display on load
                this.updateSaltSprayPriceDisplay();
            }
        }
        
        updateSaltSprayPriceDisplay() {
            const saltSprayCheckbox = document.querySelector('input[name="salt_spray_coating"]');
            if (saltSprayCheckbox && productConfig.salt_spray_coating && selectedStroke.range) {
                const label = saltSprayCheckbox.nextElementSibling || 
                             saltSprayCheckbox.parentElement.querySelector(`label[for="${saltSprayCheckbox.id}"]`);
                
                if (label) {
                    const coatingConfig = productConfig.salt_spray_coating.find(coating => 
                        selectedStroke.range >= coating.size_min && 
                        selectedStroke.range <= coating.size_max
                    );
                    
                    if (coatingConfig) {
                        label.innerHTML = `Salt Spray Coating (+$${(coatingConfig.price / 100).toFixed(2)})`;
                    } else {
                        label.innerHTML = `Salt Spray Coating (Not available for this stroke size)`;
                        saltSprayCheckbox.disabled = true;
                    }
                }
            }
        }
      
        updateVoltage() {
            if(!voltageOptions || !productConfig.voltages) return;
            
            voltageOptions.forEach(opt => {
                if(opt.checked) {
                    selectedVoltage.value = opt.value;
                    // Get price from data attribute
                    const priceFromAttr = opt.dataset.price;
                    if (priceFromAttr && priceFromAttr !== '') {
                        selectedVoltage.price = Number(priceFromAttr);
                    } else {
                        // Fallback: find in config
                        const voltageConfig = productConfig.voltages.find(v => v.value === opt.value);
                        selectedVoltage.price = voltageConfig ? voltageConfig.price : 0;
                    }
                }
            });
            
            localStorage.setItem('selectedVoltage', selectedVoltage.value);
            return selectedVoltage;
        }

        updateForceParams() {
            const vdc12Params = document.querySelectorAll('.force-table .data-12');
            const vdc24Params = document.querySelectorAll('.force-table .data-24');

            switch(selectedVoltage.value) {
                case '12 VDC':
                    vdc12Params.forEach(el => el.classList.remove('hidden'));
                    vdc24Params.forEach(el => el.classList.add('hidden'));
                    break;
                case '24 VDC':
                    vdc12Params.forEach(el => el.classList.add('hidden'));
                    vdc24Params.forEach(el => el.classList.remove('hidden'));
                    break;
            }
        }

        updateWireExt() {
            if(!wireOptions || !productConfig.wire_lengths) return;
            
            selectedWireLength.price = 0;
            wireOptions.forEach(opt => {
                if(opt.checked) {
                    selectedWireLength.value = opt.value;
                    // Get price from data attribute (it's in cents in the data attribute)
                    const priceFromAttr = opt.dataset.price;
                    if (priceFromAttr && priceFromAttr !== '') {
                        selectedWireLength.price = Number(priceFromAttr);
                    } else {
                        // Fallback: find in config
                        const wireConfig = productConfig.wire_lengths.find(w => w.value === opt.value);
                        selectedWireLength.price = wireConfig ? wireConfig.price : 0;
                    }
                }
            });
            
            localStorage.setItem('selectedWire', selectedWireLength.value);

            return selectedWireLength;
        }

        updateFeedback() {
            if(!feedbackOptions || !productConfig.feedbacks) return;

            selectedFeedback.price = 0;
            feedbackOptions.forEach(opt => {
                if(opt.checked) {
                    selectedFeedback.value = opt.value;
                    // Get price from data attribute
                    const priceFromAttr = opt.dataset.price;
                    if (priceFromAttr && priceFromAttr !== '') {
                        selectedFeedback.price = Number(priceFromAttr);
                    } else {
                        // Fallback: find in config
                        const feedbackConfig = productConfig.feedbacks.find(f => f.value === opt.value);
                        selectedFeedback.price = feedbackConfig ? feedbackConfig.price : 0;
                    }
                }
            });
            
            localStorage.setItem('selectedFeedback', selectedFeedback.value);
            return selectedFeedback;
        }

        updateForceOpt() {
            if(!forceOptions || !productConfig.forces) return;

            selectedForce.price = 0;
            forceOptions.forEach(opt => {
                if(opt.checked) {
                    selectedForce.value = opt.value;
                    // Get price from data attribute
                    const priceFromAttr = opt.dataset.price;
                    if (priceFromAttr && priceFromAttr !== '') {
                        selectedForce.price = Number(priceFromAttr);
                    } else {
                        // Fallback: find in config
                        const forceConfig = productConfig.forces.find(f => f.value === opt.value);
                        selectedForce.price = forceConfig ? forceConfig.price : 0;
                    }
                }
            });
            
            localStorage.setItem('selectedForce', selectedForce.value);
            return selectedForce;
        }

        hsFormCreate() {
            document.getElementById("openFormBtn").addEventListener("click", function () {
                // Clean up existing iframe manually if it exists
                const oldIframe = document.querySelector("iframe[id^='hs-form-iframe']");
                if (oldIframe && oldIframe.parentNode) {
                    oldIframe.parentNode.removeChild(oldIframe);
                }

                // Create overlay
                const popup = document.createElement("div");
                popup.style.position = "fixed";
                popup.style.top = "0";
                popup.style.left = "0";
                popup.style.width = "100vw";
                popup.style.height = "100vh";
                popup.style.backgroundColor = "rgba(0,0,0,0.5)";
                popup.style.display = "flex";
                popup.style.alignItems = "center";
                popup.style.justifyContent = "center";
                popup.style.zIndex = "1000";

                // Close on outside click
                popup.addEventListener("click", (e) => {
                    if (e.target === popup) {
                        document.body.removeChild(popup);
                    }
                });

                // Content container
                const content = document.createElement("div");
                content.style.backgroundColor = "white";
                content.style.padding = "30px";
                content.style.borderRadius = "12px";
                content.style.width = "90%";
                content.style.maxWidth = "600px";
                content.style.position = "relative";

                const uniqueId = 'hubspot-form-popup-' + Date.now();
                content.id = uniqueId;

                // Close icon
                const closeIcon = document.createElement("span");
                closeIcon.innerHTML = "&times;";
                closeIcon.style.position = "absolute";
                closeIcon.style.top = "10px";
                closeIcon.style.right = "15px";
                closeIcon.style.fontSize = "28px";
                closeIcon.style.cursor = "pointer";
                closeIcon.onclick = () => document.body.removeChild(popup);

                content.innerHTML = '';
                content.appendChild(closeIcon);

                popup.appendChild(content);
                document.body.appendChild(popup);

                // Get values before creating the form
                const stroke_val = localStorage.getItem('selectedStroke');
                const voltage_val = localStorage.getItem('selectedVoltage');
                const feedback_val = localStorage.getItem('selectedFeedback');
                const wire_val = localStorage.getItem('selectedWire');
                const force_val = localStorage.getItem('selectedForce');

                console.log('Form values to prefill:', {
                    stroke_val,
                    voltage_val,
                    feedback_val,
                    wire_val,
                    force_val
                });

                // Inject HubSpot form
                hbspt.forms.create({
                    target: '#' + uniqueId,
                    portalId: "7717445",
                    formId: "4c4f13a5-7f29-49e2-8cbd-280d7882e5dd",
                    region: "na1",
                    onFormReady: function ($form) {
                        console.log('Form ready', $form);
                        
                        // Try to fill the form fields using jQuery if available
                        if ($ && $form) {
                            setTimeout(() => {
                                try {
                                    // Method 1: Using jQuery to find and fill inputs
                                    $form.find('input[name="2-956907/required_stroke_size_mm"]').val(stroke_val || '');
                                    $form.find('input[name="2-956907/required_voltage__vdc_"]').val(voltage_val || '');
                                    $form.find('input[name="2-956907/required_wire_length"]').val(wire_val || '');
                                    $form.find('input[name="2-956907/required_feedback"]').val(feedback_val || '');
                                    $form.find('input[name="2-956907/required_force_dynamic_static_mm"]').val(force_val || '');
                                    
                                    // Trigger change events
                                    $form.find('input[name="2-956907/required_stroke_size_mm"]').trigger('change');
                                    $form.find('input[name="2-956907/required_voltage__vdc_"]').trigger('change');
                                    $form.find('input[name="2-956907/required_wire_length"]').trigger('change');
                                    $form.find('input[name="2-956907/required_feedback"]').trigger('change');
                                    $form.find('input[name="2-956907/required_force_dynamic_static_mm"]').trigger('change');
                                    
                                    console.log('Form fields filled using jQuery method');
                                } catch (e) {
                                    console.warn("jQuery method failed:", e);
                                    
                                    // Method 2: Fallback to vanilla JS
                                    try {
                                        const fillField = (name, value) => {
                                            const input = document.querySelector(`input[name="${name}"]`);
                                            if (input && value) {
                                                input.value = value;
                                                input.dispatchEvent(new Event('change', { bubbles: true }));
                                                input.dispatchEvent(new Event('input', { bubbles: true }));
                                            }
                                        };

                                        fillField("2-956907/required_stroke_size_mm", stroke_val);
                                        fillField("2-956907/required_voltage__vdc_", voltage_val);
                                        fillField("2-956907/required_wire_length", wire_val);
                                        fillField("2-956907/required_feedback", feedback_val);
                                        fillField("2-956907/required_force_dynamic_static_mm", force_val);
                                        
                                        console.log('Form fields filled using vanilla JS method');
                                    } catch (e2) {
                                        console.warn("Vanilla JS method also failed:", e2);
                                    }
                                }
                            }, 1000); // Increased timeout to ensure form is fully loaded
                        }
                    },
                    onFormSubmitted: function () {
                        // Optional: close popup after form submit
                        setTimeout(() => {
                            if (popup.parentNode) {
                                document.body.removeChild(popup);
                            }
                        }, 500);
                    }
                });
            });
        }
        connectedCallback() {
           
            if(document.querySelector('.quoteWrapper')) {
                document.addEventListener('click', function(e){
                    var el = e.target;
                
                    if(el.classList.contains('qouteButton') || el.closest('.qouteButton')) {
                        if(!el.classList.contains('qouteButton')) {
                            el = el.closest('.qouteButton');
                        }
                
                        e.preventDefault();
                        const parentWrapperEl = el.closest('.quoteWrapper');
                        if(parentWrapperEl) {
                        const quotePopupEl = parentWrapperEl.querySelector('.quote-popup');
                            if(quotePopupEl) {
                            quotePopupEl.classList.add('show');
                            }
                        }     
                    }
                });
                document.addEventListener('click', function(e){
                    var el = e.target;
                
                    if(el.classList.contains('quote-popup-close-btn') || el.closest('.quote-popup-close-btn')) {
                        if(!el.classList.contains('quote-popup-close-btn')) {
                            el = el.closest('.quote-popup-close-btn');
                        }
                        e.preventDefault();
                        const quotePopupEl = el.closest('.quote-popup');
                            if(quotePopupEl) {
                            quotePopupEl.classList.remove('show');
                            }
                    }
                });
                document.addEventListener('click', function(e){
                    var el = e.target;
            
                    const quotePopup = document.querySelector('.quote-popup');
                    const isClosest = el.closest('.quoteWrapper');
            
                if (isClosest == null && quotePopup.classList.contains("show")) {
                    quotePopup.classList.toggle('show');
                    }  
                });
            }   
        }
        updateTotalPrice() {
          
            let baseItemPrice = variantPrice + selectedStroke.price + selectedFeedback.price + selectedWireLength.price + selectedForce.price;
    
            selectedOtherOptions.forEach(option => {
                baseItemPrice += option.price;
            });
            
            if (selectedSaltSprayCoating.value) {
                baseItemPrice += selectedSaltSprayCoating.price;
            }
    
            totalPrice = baseItemPrice * actuatorsQty;
               
            if (priceWrapper) {
                priceWrapper.innerHTML = formatMoney(totalPrice, window.moneyFormat);;
            }

            // Per-item air freight fee (in cents); for 8+ items use weight-based formula
            airFreightFee = this.computeFreightFeePerUnitForQty(actuatorsQty);

            const selConfig = `
                <li>Stroke Size: ${selectedStroke.price / 100} USD</li>
                <li>Voltage: ${selectedVoltage.price / 100} USD</li>
                <li>Feedback: ${selectedFeedback.price / 100} USD</li>
                <li>Wire length: ${selectedWireLength.price / 100} USD</li>
                <li>Force: ${selectedForce.price / 100} USD</li>
                ${selectedOtherOptions.map(opt => `<li>${opt.value}: ${opt.price / 100} USD</li>`).join('')}
                ${selectedSaltSprayCoating.value ? `<li>${selectedSaltSprayCoating.value}: ${selectedSaltSprayCoating.price / 100} USD</li>` : ''}
                <li>Air Freight Fee: ${airFreightFee / 100} USD per Unit</li>
            `;

            optionsList.innerHTML = selConfig;
            // Keep tooltip content in sync with latest fee logic
            this.updateShippingTooltipContent();
            return totalPrice;
        }



      arrayCreate() {
          custom_arr = [];
          const customId = `custom-conf-${Date.now()}`;
          
          // Calculate base item price for cart properties
          let baseItemPrice = variantPrice + selectedStroke.price + selectedFeedback.price + selectedWireLength.price + selectedForce.price;
          selectedOtherOptions.forEach(option => {
              baseItemPrice += option.price;
          });
          if (selectedSaltSprayCoating.value) {
              baseItemPrice += selectedSaltSprayCoating.price;
          }
          
          if (variant && variantPrice) {
              custom_arr.push({
                  id: variant,
                  quantity: actuatorsQty,
                  properties: {
                      _customId: customId,
                      'Stroke Size (mm)': selectedStroke.range,
                      'Voltage': selectedVoltage.value,
                      'Feedback': selectedFeedback.value,
                      'Wire Length (mm)': selectedWireLength.value,
                      'Force': selectedForce.value,
                      // Add other options
                      ...selectedOtherOptions.reduce((acc, opt, index) => {
                          acc[`Other Option ${index + 1}`] = opt.value;
                          acc[`_other_option_${index + 1}_price`] = opt.price;
                          return acc;
                      }, {}),
                      // Add salt spray coating if selected
                      ...(selectedSaltSprayCoating.value ? {
                          'Salt Spray Coating': 'Yes',
                          '_salt_spray_coating_price': selectedSaltSprayCoating.price
                      } : {}),
                      _stroke_price: selectedStroke.price,
                      _airFreightFee: airFreightFee,
                      _voltage_price: selectedVoltage.price,
                      _feedback_price: selectedFeedback.price,
                      _wire_price: selectedWireLength.price,
                      _force_price: selectedForce.price,
                      _total_price: baseItemPrice,
                      '_min_stroke_size': productConfig.min_stroke_size,
                      '_stroke_range': selectedStroke.range,
                      '_stroke_fee': selectedStroke.fee,
                      '_weight_per_extra_mm': productConfig.weight_per_extra_mm,
                      '_min_stroke_weight': productConfig.min_stroke_weight,
                      'Note': 'Air Freight fees are included in the item prices above.'
                  }
              });
          } else {
              return;
          }
          
          if (custom_arr.length) {
              return custom_arr;
          }
      }
        calculateShipping() {
            const shippingResultsDiv = document.querySelector('.shipping_results');
            
            if (!shippingResultsDiv) {
                console.error('Shipping results div not found');
                return;
            }

            // Get product title and SKU from the page
            const productTitle = document.querySelector('.product__title h1, .product__title h2')?.textContent?.trim() || 'Product';
            const skuElement = document.querySelector('.product__sku');
            let productSku = 'N/A';
            
            if (skuElement) {
                // Extract SKU from text like "SKU: ABC123"
                const skuText = skuElement.textContent || skuElement.innerText;
                productSku = skuText.replace(/SKU:\s*/i, '').trim();
            }

            // Calculate shipping cost based on current configuration
            const shippingCost = this.calculateAirFreightFee();
            const perUnitFreight = this.computeFreightFeePerUnitForQty(actuatorsQty);

            // Create the shipping results HTML
            const shippingResultsHTML = `
                <h4>Estimated Shipping Cost</h4>
                <div class="shipping-breakdown">
                    <strong>${productTitle} (${productSku}):</strong>
                    <ul>
                        <li>Stroke Size: ${selectedStroke.range || 'Not selected'} mm</li>
                        <li>Voltage: ${selectedVoltage.value || 'Not selected'}</li>
                        <li>Feedback: ${selectedFeedback.value || 'Not selected'}</li>
                        <li>Wire length: ${selectedWireLength.value || 'Not selected'}</li>
                        <li>Force: ${selectedForce.value || 'Not selected'}</li>
                        <li>Quantity: ${actuatorsQty}</li>
                    </ul>
                    <div class="air-freight-total">
                        <strong>Air Freight Fee Total: ${(shippingCost / 100).toFixed(2)} USD</strong>
                        <div class="air-freight-per-unit">(${(perUnitFreight / 100).toFixed(2)} USD per unit × ${actuatorsQty})</div>
                    </div>
                </div>
            `;

            // Update the shipping results div
            shippingResultsDiv.innerHTML = shippingResultsHTML;
            shippingResultsDiv.classList.remove('hidden');
            
            console.log('Shipping calculation completed', {
                shippingCost: shippingCost / 100,
                quantity: actuatorsQty,
                strokeRange: selectedStroke.range,
                strokeFee: selectedStroke.fee
            });
        }

        setupParameterChangeListeners() {
            // Hide shipping results when stroke size changes
            const strokeSelect = document.getElementById('actuator-stroke');
            if (strokeSelect) {
                strokeSelect.addEventListener('change', () => {
                    this.hideShippingResults();
                });
            }

            // Hide shipping results when voltage changes
            const voltageOptions = document.getElementsByName('voltage');
            voltageOptions.forEach(option => {
                option.addEventListener('change', () => {
                    this.hideShippingResults();
                });
            });

            // Hide shipping results when feedback changes
            const feedbackOptions = document.getElementsByName('feedback');
            feedbackOptions.forEach(option => {
                option.addEventListener('change', () => {
                    this.hideShippingResults();
                });
            });

            // Hide shipping results when wire length changes
            const wireOptions = document.getElementsByName('wire_length');
            wireOptions.forEach(option => {
                option.addEventListener('change', () => {
                    this.hideShippingResults();
                });
            });

            // Hide shipping results when force changes
            const forceOptions = document.getElementsByName('force');
            forceOptions.forEach(option => {
                option.addEventListener('change', () => {
                    this.hideShippingResults();
                });
            });

           
        }

        calculateAirFreightFee() {

            const perUnit = this.computeFreightFeePerUnitForQty(actuatorsQty);
            return perUnit * actuatorsQty;
        }

        setupShippingTooltip() {
            const wrapper = document.querySelector('.shipping_info_wrapper');
            if (!wrapper) return;
            const tooltip = wrapper.querySelector('.shipping-tooltip-content');
            const icon = wrapper.querySelector('.shipping-tooltip-icon') || wrapper.querySelector('.shipping-tooltip');
            if (!tooltip) return;

            // Initialize hidden
            tooltip.style.display = 'none';

            wrapper.addEventListener('mouseenter', () => {
                this.updateShippingTooltipContent();
                tooltip.style.display = 'block';
                this.positionShippingTooltip(wrapper, tooltip, icon);
            });
            wrapper.addEventListener('mouseleave', () => {
                tooltip.style.display = 'none';
            });

            // Touch/click support for mobile devices
            const supportsTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
            if (supportsTouch) {
                wrapper.addEventListener('click', (e) => {
                    e.preventDefault();
                    const isVisible = tooltip.style.display === 'block';
                    if (isVisible) {
                        tooltip.style.display = 'none';
                        this.detachTooltipOutsideHandler(wrapper, tooltip);
                    } else {
                        this.updateShippingTooltipContent();
                        tooltip.style.display = 'block';
                        this.positionShippingTooltip(wrapper, tooltip, icon);
                        this.attachTooltipOutsideHandler(wrapper, tooltip);
                    }
                });
            }
        }

        updateShippingTooltipContent() {
            const wrapper = document.querySelector('.shipping_info_wrapper');
            if (!wrapper) return;
            const tooltip = wrapper.querySelector('.shipping-tooltip-content');
            if (!tooltip) return;

            // Per-unit fees in cents
            const perUnit1to6 = this.getFreightFeeFromConfig(selectedStroke.range) || 0;
            const perUnit7plus = this.computeWeightBasedFreightFeeCents() || 0;

            tooltip.innerHTML = `
                <strong>For 1–6 units:</strong> ${(perUnit1to6 / 100).toFixed(2)} USD per Unit.<br/>
                <strong>For 7+ units:</strong> ${(perUnit7plus / 100).toFixed(2)} USD per Unit.
            `;
        }

        positionShippingTooltip(wrapper, tooltip, icon) {
            if (!wrapper || !tooltip) return;
            const anchor = icon || wrapper;
            const viewportPadding = 12;

            // anchor to icon's left edge by default
            tooltip.style.left = '0';
            tooltip.style.right = 'auto';
            tooltip.style.transform = 'translateY(0)';
            tooltip.classList.remove('align-left', 'align-right', 'align-center');

            const anchorRect = anchor.getBoundingClientRect();
            const tipRect = tooltip.getBoundingClientRect();
            const vw = window.innerWidth || document.documentElement.clientWidth;

            // Calculate space to right and left of anchor
            const spaceRight = vw - (anchorRect.left + tipRect.width + 16);
            const spaceLeft = anchorRect.left - 16;

            if (spaceRight < 0 && spaceLeft > spaceRight) {
                // Align right to keep inside viewport
                tooltip.style.left = 'auto';
                tooltip.style.right = '0';
                tooltip.classList.add('align-right');
            } else {
                // Keep left alignment
                tooltip.style.left = '0';
                tooltip.classList.add('align-left');
            }
        }

        attachTooltipOutsideHandler(wrapper, tooltip) {
            if (this._tooltipOutsideHandler) return;
            this._tooltipOutsideHandler = (ev) => {
                if (!wrapper.contains(ev.target)) {
                    tooltip.style.display = 'none';
                    this.detachTooltipOutsideHandler(wrapper, tooltip);
                }
            };
            document.addEventListener('click', this._tooltipOutsideHandler, { passive: true, capture: true });
            document.addEventListener('touchstart', this._tooltipOutsideHandler, { passive: true, capture: true });
            window.addEventListener('scroll', this._tooltipOutsideHandler, { passive: true, capture: true });
            window.addEventListener('resize', this._tooltipOutsideHandler, { passive: true });
        }

        detachTooltipOutsideHandler() {
            if (!this._tooltipOutsideHandler) return;
            document.removeEventListener('click', this._tooltipOutsideHandler, { capture: true });
            document.removeEventListener('touchstart', this._tooltipOutsideHandler, { capture: true });
            window.removeEventListener('scroll', this._tooltipOutsideHandler, { capture: true });
            window.removeEventListener('resize', this._tooltipOutsideHandler);
            this._tooltipOutsideHandler = null;
        }

        hideShippingResults() {
            const shippingResultsDiv = document.querySelector('.shipping_results');
            if (shippingResultsDiv && !shippingResultsDiv.classList.contains('hidden')) {
                shippingResultsDiv.classList.add('hidden');
                console.log('Shipping results hidden due to parameter change');
            }
        }

        setupShippingCalculation() {
            const shippingLink = document.querySelector('.shipping_calculation');
            if (shippingLink) {
                shippingLink.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.calculateShippingWithLoading();
                });
                console.log('Shipping calculation link set up');
            } else {
                console.warn('Shipping calculation link not found');
            }
        }

        calculateShippingWithLoading() {
            const shippingResultsDiv = document.querySelector('.shipping_results');
            
            if (!shippingResultsDiv) {
                console.error('Shipping results div not found');
                return;
            }

            // Show loading state
            shippingResultsDiv.innerHTML = `
                <h4>Calculating Shipping Cost</h4>
                <div class="shipping-loading">
                    Calculating air freight for your configuration...
                </div>
            `;
            shippingResultsDiv.classList.remove('hidden');

            // Simulate calculation delay for better UX
            setTimeout(() => {
                this.calculateShipping();
            }, 600);
        }

        setupQuantityChangeListener() {
            const quantityInput = document.querySelector('.quantity__input');
            if (quantityInput) {
                quantityInput.addEventListener('input', () => {
                    this.hideShippingResults();
                });
                quantityInput.addEventListener('change', () => {
                    this.hideShippingResults();
                });
            
            }
            
            // Also listen for quantity button clicks
            const quantityButtons = document.querySelectorAll('.quantity__button');
            quantityButtons.forEach(button => {
                button.addEventListener('click', () => {
                    // Small delay to ensure the value has updated
                    setTimeout(() => {
                        this.hideShippingResults();
                    }, 10);
                });
            });
        }

    }
    
    customElements.define('custom-product-info', CustomConstructor);
});